/**
 * EstabelecimentosTabs Component - Tab navigation
 */
import React from 'react';

type TabType = 'dados-gerais' | 'locais' | 'representantes';

interface EstabelecimentosTabsProps {
  activeTab: TabType;
  onTabChange: (tab: TabType) => void;
}

export const EstabelecimentosTabs: React.FC<EstabelecimentosTabsProps> = ({
  activeTab,
  onTabChange,
}) => {
  const tabs: { id: TabType; label: string }[] = [
    { id: 'dados-gerais', label: 'Dados Gerais' },
    { id: 'locais', label: 'Locais de Contagem' },
    { id: 'representantes', label: 'Representantes' },
  ];

  return (
    <div className="bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700">
      <div className="flex px-6">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={`px-4 py-3 text-sm font-medium border-b-2 ${
              activeTab === tab.id
                ? 'border-blue-500 text-blue-600 dark:text-blue-400'
                : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300'
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>
    </div>
  );
};
